'use strict';

async function SaveFormDetails(token) {
    //debugger;
    const reCaptchaVersion = document.getElementById('reCaptchaVersion').value;
    var gRecaptchaResponse;
    if (reCaptchaVersion == "ReCaptchaV2") {
        gRecaptchaResponse = $('#g-recaptcha-response').val();
    }
    else if (reCaptchaVersion == "ReCaptchaV3") {
        gRecaptchaResponse = token;
    }

    const fname = document.getElementById('evt-fname').value;
    const lname = document.getElementById('evt-lname').value;
    const email = document.getElementById('evt-email').value;
    const mobile = document.getElementById('evt-mob').value;
    const tradeName = document.getElementById('trade-name').value;
    const customerCode = document.getElementById('customer-code').value;
    const state = document.getElementById('ap-state').value;
    const homeBranch = document.getElementById('homeBranch').value;
    const homeBranchEmail = document.getElementById('homeBranchEmail').value;
    const nameOfCollage = document.getElementById('tafe').value;
    const startdate = document.getElementById('ap-start').value;
    const enddate = document.getElementById('ap-end').value;
    const birthdayDay = document.getElementById('birthdayDay').value;
    const birthdayMonth = document.getElementById('birthdayMonth').value;
    let validscterm = document.querySelectorAll('input[name="terms"]:checked');

    const charLengthErrorMessage = document.getElementById('charLimitErrorMessage').value;
    const charInvalidErrorMessage = document.getElementById('charInvalidErrorMessage').value;

    var status = "";
    var ele = document.getElementsByName('attendee');
    for (let i = 0; i < ele.length; i++) {
        if (ele[i].checked) {
            status = ele[i].value;
        }
    }

    let valid = true;

    const errorFields = [
        'errorfirstname', 'errorlastname', 'errorEmail', 'errormobile', 'errortradename',
        'errorcustomercode', 'errorstate', 'errortafe', 'errorstart', 'errorend',
        'errorstatus', 'errorterms', 'errorHomeBranch', 'errorCaptcha'
    ];

    errorFields.forEach(field => {
        document.getElementById(field).style.display = "none";
    });

    const inputFields = [
        'evt-fname', 'evt-lname', 'evt-email', 'evt-mob', 'trade-name',
        'customer-code', 'ap-state', 'terms', 'homeBranch', 'tafe',
        'ap-end', 'ap-start'
    ];

    inputFields.forEach(field => {
        document.getElementById(field).classList.remove("field-error");
    });

    if (fname === "") {
        document.getElementById('evt-fname').classList.add("field-error");
        document.getElementById('errorfirstname').style.display = "block";
        document.getElementById('errorfirstname').innerHTML = "First Name is required";
        valid = false;
    }
    else if (fname.length > 50) {
        document.getElementById('evt-fname').classList.add("field-error");
        document.getElementById('errorfirstname').style.display = "block";
        document.getElementById('errorfirstname').innerHTML = charLengthErrorMessage;
        valid = false;
    }
    else if (!IsInputNameValid(fname)) {
        document.getElementById('evt-fname').classList.add("field-error");
        document.getElementById('errorfirstname').style.display = "block";
        document.getElementById('errorfirstname').innerHTML = charInvalidErrorMessage;
        valid = false;
    }

    if (lname === "") {
        document.getElementById('evt-lname').classList.add("field-error");
        document.getElementById('errorlastname').style.display = "block";
        document.getElementById('errorlastname').innerHTML = "Last Name is required";
        valid = false;
    }
    else if (lname.length > 50) {
        document.getElementById('evt-lname').classList.add("field-error");
        document.getElementById('errorlastname').style.display = "block";
        document.getElementById('errorlastname').innerHTML = charLengthErrorMessage;
        valid = false;
    }
    else if (!IsInputNameValid(lname)) {
        document.getElementById('evt-lname').classList.add("field-error");
        document.getElementById('errorlastname').style.display = "block";
        document.getElementById('errorlastname').innerHTML = charInvalidErrorMessage;
        valid = false;
    }

    if (email === "") {
        document.getElementById('evt-email').classList.add("field-error");
        document.getElementById('errorEmail').style.display = "block";
        document.getElementById('errorEmail').innerHTML = "Email Address is required";
        valid = false;
    }
    else if (email.length > 60) {
        document.getElementById('evt-email').classList.add("field-error");
        document.getElementById('errorEmail').style.display = "block";
        document.getElementById('errorEmail').innerHTML = charLengthErrorMessage;
        valid = false;
    }
    else if (!ValidateEmailRegex(email)) {
        document.getElementById('evt-email').classList.add("field-error");
        document.getElementById('errorEmail').style.display = "block";
        document.getElementById('errorEmail').innerHTML = "Email Address is required";
        valid = false;
    }
    else if (!IsInputSecure(email, true)) {
        document.getElementById('evt-email').classList.add("field-error");
        document.getElementById('errorEmail').style.display = "block";
        document.getElementById('errorEmail').innerHTML = charInvalidErrorMessage;
        valid = false;
    }

    if (mobile === "") {
        document.getElementById('evt-mob').classList.add("field-error");
        document.getElementById('errormobile').style.display = "block";
        document.getElementById('errormobile').innerHTML = "Mobile number is required";
        valid = false;
    }
    else if (mobile.length > 15) {
        document.getElementById('evt-mob').classList.add("field-error");
        document.getElementById('errormobile').style.display = "block";
        document.getElementById('errormobile').innerHTML = charLengthErrorMessage;
        valid = false;
    }
    else if (!IsMobileValid(mobile) && mobile !== "") {
        document.getElementById('evt-mob').classList.add("field-error");
        document.getElementById('errormobile').style.display = "block";
        document.getElementById('errormobile').innerHTML = "Mobile number is required";
        valid = false;
    }

    if (tradeName === "") {
        document.getElementById('trade-name').classList.add("field-error");
        document.getElementById('errortradename').style.display = "block";
        document.getElementById('errortradename').innerHTML = "Employer's Trading Name is required";
        valid = false;
    }
    else if (tradeName.length > 100) {
        document.getElementById('trade-name').classList.add("field-error");
        document.getElementById('errortradename').style.display = "block";
        document.getElementById('errortradename').innerHTML = charLengthErrorMessage;
        valid = false;
    }
    else if (!IsInputSecure(tradeName)) {
        document.getElementById('trade-name').classList.add("field-error");
        document.getElementById('errortradename').style.display = "block";
        document.getElementById('errortradename').innerHTML = charInvalidErrorMessage;
        valid = false;
    }

    if (customerCode.length > 10) {
        document.getElementById('customer-code').classList.add("field-error");
        document.getElementById('errorcustomercode').style.display = "block";
        document.getElementById('errorcustomercode').innerHTML = charLengthErrorMessage;
        valid = false;
    }
    else if (!IsInputSecure(customerCode)) {
        document.getElementById('customer-code').classList.add("field-error");
        document.getElementById('errorcustomercode').style.display = "block";
        document.getElementById('errorcustomercode').innerHTML = charInvalidErrorMessage;
        valid = false;
    }

    if (state === "" || state == 'Select State') {
        document.getElementById('ap-state').classList.add("field-error");
        document.getElementById('errorstate').style.display = "block";
        document.getElementById('errorstate').innerHTML = "State is required";
        valid = false;
    }
    else if (state.length > 50) {
        document.getElementById('ap-state').classList.add("field-error");
        document.getElementById('errorstate').style.display = "block";
        document.getElementById('errorstate').innerHTML = charLengthErrorMessage;
        valid = false;
    }
    else if (!IsInputSecure(state)) {
        document.getElementById('ap-state').classList.add("field-error");
        document.getElementById('errorstate').style.display = "block";
        document.getElementById('errorstate').innerHTML = charInvalidErrorMessage;
        valid = false;
    }

    if (homeBranch === "") {
        document.getElementById('homeBranch').classList.add("field-error");
        document.getElementById('errorHomeBranch').style.display = "block";
        document.getElementById('errorHomeBranch').innerHTML = "Home Branch is required";
        valid = false;
    }
    else if (homeBranch.length > 100) {
        document.getElementById('homeBranch').classList.add("field-error");
        document.getElementById('errorHomeBranch').style.display = "block";
        document.getElementById('errorHomeBranch').innerHTML = charLengthErrorMessage;
        valid = false;
    }
    else if (!IsInputSecure_MiddysBranchSearch(homeBranch)) {
        document.getElementById('homeBranch').classList.add("field-error");
        document.getElementById('errorHomeBranch').style.display = "block";
        document.getElementById('errorHomeBranch').innerHTML = charInvalidErrorMessage;
        valid = false;
    }
    else if (homeBranchEmail === "") {
        document.getElementById('homeBranch').classList.add("field-error");
        document.getElementById('errorHomeBranch').style.display = "block";
        document.getElementById('errorHomeBranch').innerHTML = "Home Branch is required";
        valid = false;
    }

    if (nameOfCollage === "") {
        document.getElementById('tafe').classList.add("field-error");
        document.getElementById('errortafe').style.display = "block";
        document.getElementById('errortafe').innerHTML = "TAFE College is required";
        valid = false;
    }
    else if (nameOfCollage.length > 100) {
        document.getElementById('tafe').classList.add("field-error");
        document.getElementById('errortafe').style.display = "block";
        document.getElementById('errortafe').innerHTML = charLengthErrorMessage;
        valid = false;
    }
    else if (!IsInputSecure(nameOfCollage)) {
        document.getElementById('tafe').classList.add("field-error");
        document.getElementById('errortafe').style.display = "block";
        document.getElementById('errortafe').innerHTML = charInvalidErrorMessage;
        valid = false;
    }

    if (startdate === "") {
        document.getElementById('ap-start').classList.add("field-error");
        document.getElementById('errorstart').style.display = "block";
        document.getElementById('errorstart').innerHTML = "Apprenticeship Start Date is required";
        valid = false;
    }
    else if (!IsInputSecureDate(startdate)) {
        document.getElementById('ap-start').classList.add("field-error");
        document.getElementById('errorstart').style.display = "block";
        document.getElementById('errorstart').innerHTML = charInvalidErrorMessage;
        valid = false;
    }

    if (enddate === "") {
        document.getElementById('ap-end').classList.add("field-error");
        document.getElementById('errorend').style.display = "block";
        document.getElementById('errorend').innerHTML = "Apprenticeship End Date is required";
        valid = false;
    }
    else if (!IsInputSecureDate(enddate)) {
        document.getElementById('ap-end').classList.add("field-error");
        document.getElementById('errorend').style.display = "block";
        document.getElementById('errorend').innerHTML = charInvalidErrorMessage;
        valid = false;
    }

    if (status === "") {
        document.getElementById('errorstatus').style.display = "block";
        document.getElementById('errorstatus').innerHTML = "Status of Apprenticeship is required";
        valid = false;
    }
    else if (!IsInputSecure(status)) {
        document.getElementById('errorstatus').style.display = "block";
        document.getElementById('errorstatus').innerHTML = charInvalidErrorMessage;
        valid = false;
    }

    if (validscterm.length === 0) {
        document.getElementById('terms').classList.add("field-error");
        document.getElementById('errorterms').style.display = "block";
        valid = false;
    }
    if (reCaptchaVersion == "ReCaptchaV2") {
        const recaptcha = grecaptcha.getResponse();
        if (recaptcha === "") {
            document.getElementById('errorCaptcha').style.display = "block";
            valid = false;
        }
    }

    // server-side validation
    if (valid == true) {
        const serverValidationResult = await validateEmailAndMobile(email, mobile);
        if (serverValidationResult) {
            console.log("serverValidationResult.field --> " + serverValidationResult.field)
            if (serverValidationResult.field === "Email") {
                document.getElementById('evt-email').classList.add("field-error");
                document.getElementById('errorEmail').style.display = "block";
                document.getElementById('errorEmail').innerHTML = serverValidationResult.message;
            } else if (serverValidationResult.field === "Mobile") {
                document.getElementById('evt-mob').classList.add("field-error");
                document.getElementById('errormobile').style.display = "block";
                document.getElementById('errormobile').innerHTML = serverValidationResult.message;
            }
            valid = false;
        }
    }

    if (valid == true) {
        document.getElementById('errorCaptcha').style.display = "none";
        document.getElementById('SubmissionErrorMessage').innerHTML = "";
        document.getElementById('SubmissionErrorMessage').style.display = "none";

        if (reCaptchaVersion == "ReCaptchaV2") {
            SubmitForm_Apprentice(fname, lname, email, mobile, tradeName, customerCode, state, homeBranch, homeBranchEmail, nameOfCollage, startdate, enddate, status, birthdayDay, birthdayMonth, gRecaptchaResponse);
        }
        else if (reCaptchaVersion == "ReCaptchaV3") {
            var siteKey = document.getElementById('reCaptchaV3SiteKey').value;
            grecaptcha.ready(function () {
                grecaptcha.execute(siteKey, { action: 'apprentice' }).then(function (gRecaptchaResponse) {
                    SubmitForm_Apprentice(fname, lname, email, mobile, tradeName, customerCode, state, homeBranch, homeBranchEmail, nameOfCollage, startdate, enddate, status, birthdayDay, birthdayMonth, gRecaptchaResponse);
                });
            });
        }
    }
    else {
        console.log(valid);
        getTabHeightTradeJs();
    }
}

function SubmitForm_Apprentice(fname, lname, email, mobile, tradeName, customerCode, state, homeBranch, homeBranchEmail, nameOfCollage, startdate, enddate, status, birthdayDay, birthdayMonth, gRecaptchaResponse) {
    let formData = new FormData();
    formData.append('FirstName', fname);
    formData.append('LastName', lname);
    formData.append('Email', email);
    formData.append('Mobile', mobile);
    formData.append('TradingName', tradeName);
    formData.append('CustomerCode', customerCode);
    formData.append('State', state);
    formData.append('HomeBranch', homeBranch);
    formData.append('HomeBranchEmail', homeBranchEmail);
    formData.append('TafeCollege', nameOfCollage);
    formData.append('StartDate', startdate);
    formData.append('EndDate', enddate);
    formData.append('Status', status);
    formData.append('BirthdayDay', birthdayDay);
    formData.append('BirthdayMonth', birthdayMonth);
    formData.append('GRecaptchaResponse', gRecaptchaResponse);

    const url = "/SaveApprenticeProgramForm";

    fetch(url,
        {
            body: formData,
            method: "post",
            headers: {
                "RequestVerificationToken": $("#apprenticeForm [name='__RequestVerificationToken']").val()
            }
        })
        .then(response => {
            if (!response.ok) {
                document.getElementById('SubmissionErrorMessage').innerHTML = $("#formSubmissionErrorMessage").val();
                document.getElementById('SubmissionErrorMessage').style.display = "block";
            }
            return response.text()
        })
        .then(data => {
            //make sure response does not contain any unhandled error
            if (!data.includes("<html>")) {
                if (data == 'Submit') {
                    //clear form
                    document.getElementById('evt-fname').value = "";
                    document.getElementById('evt-lname').value = "";
                    document.getElementById('evt-email').value = "";
                    document.getElementById('evt-mob').value = "";
                    document.getElementById('trade-name').value = "";
                    document.getElementById('ap-state').value = "";
                    document.getElementById('homeBranch').value = "";
                    document.getElementById('tafe').value = "";
                    document.getElementById('ap-start').value = "";
                    document.getElementById('ap-end').value = "";
                    $('input[type="radio"]').prop('checked', false);
                    $('input[type="radio"]').prop('checked', false);
                    document.getElementById('birthdayDay').value = "";
                    document.getElementById('birthdayMonth').value = "";
                    document.getElementById('terms').checked = false;

                    $("#ProgramFormTitle").hide();
                    document.getElementById("ProgramForm").classList.remove("active");
                    document.getElementById("successMessage").classList.add("active");
                    grecaptcha.reset();
                    nextButtonLogic(".apprentice-program-form-next");
                    //getTabHeightTradeJs();
                }
                //neither success nor exception i.e. custom error response returned
                else if (data != "Submit" && data != "false") {
                    if (data.startsWith("1")) {
                        document.getElementById('SubmissionErrorMessage').innerHTML = data.slice(1);
                        document.getElementById('SubmissionErrorMessage').style.display = "block";
                    }
                    else {
                        //error returned by failed validation of reCAPTCHA v3, display error message
                        document.getElementById('errorCaptcha').style.display = "block";
                        document.getElementById('errorCaptcha').innerHTML = data;
                    }
                }
            }
        })
        .catch(error => {
            document.getElementById('SubmissionErrorMessage').innerHTML = "An error occurred while submitting the form. Please try again.";
            document.getElementById('SubmissionErrorMessage').style.display = "block";
            console.error('Error:', error);
        });
}


function isMobile() {
    return $(window).width() < 768;
}

var nextButtonLogic = function (classname) {

    var st = $('.tabs-wrap').offset().top;
    // console.log(st);
    var tabN = $(classname).parents('.tab').next().height();
    var tabP = $(classname).parents('.tab').prev().height();
    $(classname).parents('.tab').animate({
        left: '-100%'
    });
    $(classname).parents('.tab').next().animate({
        left: '0'
    });
    $('.tabs-nav .tab.active').addClass('complete').removeClass('active').next().addClass('active');
    $(classname).parents('.tab').removeClass('active').next().addClass('active');
    $('.tabs-wrap').height(tabN);
    formPlacement();
    if (!isMobile()) {
        $('html').animate({
            scrollTop: st - 220
        })
    }
    else {
        $('html').animate({
            scrollTop: st - 120
        })
    }
    headingCheck();
    getTabHeightTradeJs();
}

function formPlacement() {
    if ($('.keep-updated-block').length > 0) {
        var countY = $('.keep-updated-block').outerHeight();
        var mid = countY / 2;
        $('footer').css({
            'margin-top': '-' + mid + 'px',
            'padding-top': mid + 60
        });
    }

    if ($('.register-form-block').length > 0) {
        if (!isMobile()) {
            var countY = $('.register-form-block .container').outerHeight();
            var mid = countY / 2;
            var repo = mid + 60;
            $('.register-form-block').css({
                height: repo
            });

            $('.register-form-block .container').css({
                top: '-' + mid + 'px'
            });

            $('.register-form-block').prev().css({
                'margin-bottom': repo
            });

            $('.register-form-block').parents('.fr-view').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                'margin-bottom': repo
            });

            $('.register-form-block').parents('div').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                'margin-bottom': repo
            });

            var tabY = $('.tabs-wrap .tab.active').outerHeight();
            $('.tabs-wrap').height(tabY);
        }
        else {
            $('.register-form-block').css({
                height: ''
            });

            $('.register-form-block .container').css({
                top: ''
            });

            $('.register-form-block').prev().css({
                'margin-bottom': ''
            });

            $('.register-form-block').parents('.fr-view').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                'margin-bottom': ''
            });

            $('.register-form-block').parents('div').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                'margin-bottom': ''
            });

            var tabY = $('.tabs-wrap .tab.active').outerHeight();
            $('.tabs-wrap').height(tabY);
        }
    }
}
function headingCheck() {
    if ($('.tabs-wrap .tab.success-screen').hasClass('active')) {
        $('.trade-registration-block .container > h2').hide();
    }
    else {
        $('.trade-registration-block .container > h2').show();
    }
}

function getTabHeightTradeJs() {
    var tabActive = $('.tabs-wrap .tab.active').outerHeight();
    $('.tabs-wrap').css('height', tabActive);
    setTimeout(formPlacementTradeJs, 500)
}

function formPlacementTradeJs() {
    if ($('.keep-updated-block').length > 0) {
        var countY = $('.keep-updated-block').outerHeight();
        var mid = countY / 2;
        $('footer').css({
            'margin-top': '-' + mid + 'px',
            'padding-top': mid + 60
        });
    }

    if ($('.register-form-block').length > 0) {
        if (!isMobile()) {
            var countY = $('.register-form-block .container').outerHeight();
            var mid = countY / 2;
            var repo = mid + 60;
            $('.register-form-block').css({
                height: repo
            });

            $('.register-form-block .container').css({
                top: '-' + mid + 'px'
            });

            $('.register-form-block').prev().css({
                'margin-bottom': repo
            });

            $('.register-form-block').parents('.fr-view').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                'margin-bottom': repo
            });

            $('.register-form-block').parents('div').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                'margin-bottom': repo
            });

            var tabY = $('.tabs-wrap .tab.active').outerHeight();
            $('.tabs-wrap').height(tabY);
        }
        else {
            $('.register-form-block').css({
                height: ''
            });

            $('.register-form-block .container').css({
                top: ''
            });

            $('.register-form-block').prev().css({
                'margin-bottom': ''
            });

            $('.register-form-block').parents('.fr-view').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                'margin-bottom': ''
            });

            $('.register-form-block').parents('div').prev().not('.breadcrumbs, .sticky-floater, .service-features-block, .sleevesup-page > div').css({
                'margin-bottom': ''
            });

            var tabY = $('.tabs-wrap .tab.active').outerHeight();
            $('.tabs-wrap').height(tabY);
        }
    }
}


$("#homeBranch").keyup(function (e) {

    var txt = $(this).val().trim();

    if (txt != "") {
        const url = "/api/branchlocator/SearchBranchByName?search=" + txt;

        fetch(url, {
            headers: {
                'Content-Type': 'application/json',
                "RequestVerificationToken": $("#checkloginApi [name='__RequestVerificationToken']").val()
            },
        })
            .then(response => response.text())
            .then(data => bindhomebranch(data))
            .catch(error => {
                document.getElementById('SubmissionErrorMessage').innerHTML = "An error occurred while fetching branch data. Please try again.";
                document.getElementById('SubmissionErrorMessage').style.display = "block";
                console.error('Error:', error);
            });
    }
    else {
        document.getElementById("autocomplete-wrap").style.display = "none";
    }

});

function bindhomebranch(data) {
    let jsobject = JSON.parse(data);
    let divElement = document.getElementById("autocomplete-wrap");
    divElement.style.display = "block";
    divElement.innerHTML = "";
    if (jsobject.length === 0) {
        let aelem = document.createElement("a");
        aelem.className = "autocomplete-items";
        aelem.innerHTML = "No Result Found";
        divElement.appendChild(aelem);
    } else {
        for (let i = 0; i <= jsobject.length - 1; i++) {
            let aelem = document.createElement("a");
            aelem.className = "autocomplete-items";
            aelem.dataset.url = "/branch-locator/" + jsobject[i].state.toLowerCase().trim() + "/" + jsobject[i].slug;
            aelem.innerHTML = jsobject[i].name;
            aelem.dataset.email = jsobject[i].email;
            aelem.id = i;
            aelem.setAttribute('onclick', "inputhomebranch(event)");
            divElement.appendChild(aelem);
        }
    }
    document.getElementById("id1").appendChild(divElement);
}


function inputhomebranch(event) {
    const value = event.currentTarget.innerHTML;
    const branchUrl = event.currentTarget.dataset.url;
    const branchEmail = event.currentTarget.dataset.email;
    document.getElementById('homeBranch').value = value;
    document.getElementById('homeBranchEmail').value = branchEmail;
    document.getElementById("autocomplete-wrap").style.display = "none";

    $("#middysBranch").attr("href", branchUrl);
    $("#middysBranch").html(value);

}

async function validateEmailAndMobile(email, mobile) {
    try {
        const response = await fetch('/ValidateApprenticeProgramForm', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                "RequestVerificationToken": $("#apprenticeForm [name='__RequestVerificationToken']").val()
            },
            body: JSON.stringify({ email: email, mobile: mobile })
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(JSON.stringify(errorData));
        }

        return null;
    } catch (error) {
        return JSON.parse(error.message);
    }
}